export default __webpack_public_path__ + "static/media/xrp.bc361c3c.png";